import produce from 'immer';

export const Types = {
  GET_PERMISSAO_SEGUNDA_VIA_REQUEST:
    '@requisicao/GET_PERMISSAO_SEGUNDA_VIA_REQUEST',
  GET_PERMISSAO_SEGUNDA_VIA_SUCCESS:
    '@requisicao/GET_PERMISSAO_SEGUNDA_VIA_SUCCESS',
  GET_PERMISSAO_SEGUNDA_VIA_ERROR:
    '@requisicao/GET_PERMISSAO_SEGUNDA_VIA_ERROR',
  POST_SOLICITAR_RELATORIO_SEGUNDA_VIA_REQUEST:
    '@requisicao/POST_SOLICITAR_RELATORIO_SEGUNDA_VIA_REQUEST',
  POST_SOLICITAR_RELATORIO_SEGUNDA_VIA_SUCCESS:
    '@requisicao/POST_SOLICITAR_RELATORIO_SEGUNDA_VIA_SUCCESS',
  POST_SOLICITAR_RELATORIO_SEGUNDA_VIA_ERROR:
    '@requisicao/POST_SOLICITAR_RELATORIO_SEGUNDA_VIA_ERROR',
  POST_SOLICITAR_SEGUNDA_VIA_REQUEST:
    '@requisicao/POST_SOLICITAR_SEGUNDA_VIA_REQUEST',
  POST_SOLICITAR_SEGUNDA_VIA_SUCCESS:
    '@requisicao/POST_SOLICITAR_SEGUNDA_VIA_SUCCESS',
  POST_SOLICITAR_SEGUNDA_VIA_ERROR:
    '@requisicao/POST_SOLICITAR_SEGUNDA_VIA_ERROR',
  POST_BENEFICIARIOS_SEGUNDA_VIA_REQUEST:
    '@requisicao/POST_BENEFICIARIOS_SEGUNDA_VIA_REQUEST',
  POST_BENEFICIARIOS_SEGUNDA_VIA_SUCCESS:
    '@requisicao/POST_BENEFICIARIOS_SEGUNDA_VIA_SUCCESS',
  POST_BENEFICIARIOS_SEGUNDA_VIA_ERROR:
    '@requisicao/POST_BENEFICIARIOS_SEGUNDA_VIA_ERROR',
  DELETE_SEGUNDA_VIA_REQUEST: '@requisicao/DELETE_SEGUNDA_VIA_REQUEST',
  DELETE_SEGUNDA_VIA_SUCCESS: '@requisicao/DELETE_SEGUNDA_VIA_SUCCESS',
  DELETE_SEGUNDA_VIA_ERROR: '@requisicao/DELETE_SEGUNDA_VIA_ERROR',
  DELETE_SEGUNDA_VIA_ANEXO_REQUEST:
    '@requisicao/DELETE_SEGUNDA_VIA_ANEXO_REQUEST',
  DELETE_SEGUNDA_VIA_ANEXO_SUCCESS:
    '@requisicao/DELETE_SEGUNDA_VIA_ANEXO_SUCCESS',
  DELETE_SEGUNDA_VIA_ANEXO_ERROR: '@requisicao/DELETE_SEGUNDA_VIA_ANEXO_ERROR',
  GET_SEGUNDA_VIA_ANEXO_REQUEST: '@requisicao/GET_SEGUNDA_VIA_ANEXO_REQUEST',
  GET_SEGUNDA_VIA_ANEXO_SUCCESS: '@requisicao/GET_SEGUNDA_VIA_ANEXO_SUCCESS',
  GET_SEGUNDA_VIA_ANEXO_ERROR: '@requisicao/GET_SEGUNDA_VIA_ANEXO_ERROR',
  PUT_SEGUNDA_VIA_UPDATE_REQUEST: '@requisicao/PUT_SEGUNDA_VIA_UPDATE_REQUEST',
  PUT_SEGUNDA_VIA_UPDATE_SUCCESS: '@requisicao/PUT_SEGUNDA_VIA_UPDATE_SUCCESS',
  PUT_SEGUNDA_VIA_UPDATE_ERROR: '@requisicao/PUT_SEGUNDA_VIA_UPDATE_ERROR',
  POST_SEGUNDA_VIA_BUSCAR_POR_ID_REQUEST:
    '@requisicao/POST_SEGUNDA_VIA_BUSCAR_POR_ID_REQUEST',
  POST_SEGUNDA_VIA_BUSCAR_POR_ID_SUCCESS:
    '@requisicao/POST_SEGUNDA_VIA_BUSCAR_POR_ID_SUCCESS',
  POST_SEGUNDA_VIA_BUSCAR_POR_ID_ERROR:
    '@requisicao/POST_SEGUNDA_VIA_BUSCAR_POR_ID_ERROR',
  POST_SEGUNDA_VIA_PROCESSAR_REQUEST:
    '@requisicao/POST_SEGUNDA_VIA_PROCESSAR_REQUEST',
  POST_SEGUNDA_VIA_PROCESSAR_SUCCESS:
    '@requisicao/POST_SEGUNDA_VIA_PROCESSAR_SUCCESS',
  POST_SEGUNDA_VIA_PROCESSAR_ERROR:
    '@requisicao/POST_SEGUNDA_VIA_PROCESSAR_ERROR',
  POST_SEGUNDA_VIA_CARTAO_REQUEST:
    '@requisicao/POST_SEGUNDA_VIA_CARTAO_REQUEST',
  POST_SEGUNDA_VIA_CARTAO_SUCCESS:
    '@requisicao/POST_SEGUNDA_VIA_CARTAO_SUCCESS',
  POST_SEGUNDA_VIA_CARTAO_ERROR: '@requisicao/POST_SEGUNDA_VIA_CARTAO_ERROR',
};

const INITIAL_STATE = {
  getPermissaoSegundaVia: {
    loading: false,
    success: false,
    response: {},
    unsuccessResponse: [],
    error: null,
    isError: false,
  },
  postRelatorioSegundaVia: {
    loading: false,
    success: false,
    response: {},
    unsuccessResponse: [],
    error: null,
    isError: false,
  },
  getBeneficiarios: {
    loading: false,
    success: false,
    response: [],
    unsuccessResponse: [],
    error: null,
    isError: false,
  },
  deleteSegundaVia: {
    loading: false,
    success: false,
    response: {},
    unsuccessResponse: [],
    error: null,
    isError: false,
  },
  postSegundaViaCartao: {
    loading: false,
    success: false,
    response: {},
    unsuccessResponse: [],
    error: null,
    isError: false,
  },
  getSegundaViaCartao: {
    loading: false,
    success: false,
    response: {},
    unsuccessResponse: [],
    error: null,
    isError: false,
  },
  getAnexoSegundaVia: {
    loading: false,
    success: false,
    response: {},
    unsuccessResponse: [],
    error: null,
    isError: false,
  },
  putSegundaViaCartao: {
    loading: false,
    success: false,
    response: {},
    unsuccessResponse: [],
    error: null,
    isError: false,
  },
  postProcessarSegundaVia: {
    loading: false,
    success: false,
    response: {},
    unsuccessResponse: [],
    error: null,
    isError: false,
  },
};

export default function requisicao(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case Types.GET_PERMISSAO_SEGUNDA_VIA_REQUEST: {
        draft.getPermissaoSegundaVia.loading = true;
        break;
      }
      case Types.GET_PERMISSAO_SEGUNDA_VIA_SUCCESS: {
        draft.getPermissaoSegundaVia.loading = false;
        draft.getPermissaoSegundaVia.response = action.payload.response;
        draft.getPermissaoSegundaVia.success = action.payload.success;
        break;
      }
      case Types.GET_PERMISSAO_SEGUNDA_VIA_ERROR: {
        draft.getPermissaoSegundaVia.loading = false;
        draft.getPermissaoSegundaVia.isError = true;
        draft.getPermissaoSegundaVia.error = action.payload.error;
        break;
      }
      case Types.POST_SOLICITAR_RELATORIO_SEGUNDA_VIA_REQUEST: {
        draft.postRelatorioSegundaVia.loading = true;
        break;
      }
      case Types.POST_SOLICITAR_RELATORIO_SEGUNDA_VIA_SUCCESS: {
        draft.postRelatorioSegundaVia.loading = false;
        draft.postRelatorioSegundaVia.response = action.payload.response;
        draft.postRelatorioSegundaVia.success = action.payload.success;
        break;
      }
      case Types.POST_SOLICITAR_RELATORIO_SEGUNDA_VIA_ERROR: {
        draft.postRelatorioSegundaVia.loading = false;
        draft.postRelatorioSegundaVia.isError = true;
        draft.postRelatorioSegundaVia.error = action.payload.error;
        break;
      }
      case Types.POST_SOLICITAR_SEGUNDA_VIA_REQUEST: {
        draft.postSegundaViaCartao.loading = true;
        break;
      }
      case Types.POST_SOLICITAR_SEGUNDA_VIA_SUCCESS: {
        draft.postSegundaViaCartao.loading = false;
        draft.postSegundaViaCartao.response = action.payload.response;
        draft.postSegundaViaCartao.success = action.payload.success;
        break;
      }
      case Types.POST_SOLICITAR_SEGUNDA_VIA_ERROR: {
        draft.postSegundaViaCartao.loading = false;
        draft.postSegundaViaCartao.isError = true;
        draft.postSegundaViaCartao.error = action.payload.error;
        break;
      }
      case Types.POST_BENEFICIARIOS_SEGUNDA_VIA_REQUEST: {
        draft.getBeneficiarios.loading = true;
        break;
      }
      case Types.POST_BENEFICIARIOS_SEGUNDA_VIA_SUCCESS: {
        draft.getBeneficiarios.loading = false;
        draft.getBeneficiarios.response = action.payload.response;
        draft.getBeneficiarios.success = action.payload.success;
        break;
      }
      case Types.POST_BENEFICIARIOS_SEGUNDA_VIA_ERROR: {
        draft.getBeneficiarios.loading = false;
        draft.getBeneficiarios.isError = true;
        draft.getBeneficiarios.error = action.payload.error;
        break;
      }
      case Types.DELETE_SEGUNDA_VIA_REQUEST: {
        draft.deleteSegundaVia.loading = true;
        break;
      }
      case Types.DELETE_SEGUNDA_VIA_SUCCESS: {
        draft.deleteSegundaVia.loading = false;
        draft.deleteSegundaVia.response = action.payload.response;
        draft.deleteSegundaVia.success = action.payload.success;
        break;
      }
      case Types.DELETE_SEGUNDA_VIA_ERROR: {
        draft.deleteSegundaVia.loading = false;
        draft.deleteSegundaVia.isError = true;
        draft.deleteSegundaVia.error = action.payload.error;
        break;
      }
      case Types.DELETE_SEGUNDA_VIA_ANEXO_REQUEST: {
        draft.getAnexoSegundaVia.loading = true;
        break;
      }
      case Types.DELETE_SEGUNDA_VIA_ANEXO_SUCCESS: {
        draft.getAnexoSegundaVia.loading = false;
        draft.getAnexoSegundaVia.response = action.payload.response;
        draft.getAnexoSegundaVia.success = action.payload.success;
        break;
      }
      case Types.DELETE_SEGUNDA_VIA_ANEXO_ERROR: {
        draft.getAnexoSegundaVia.loading = false;
        draft.getAnexoSegundaVia.isError = true;
        draft.getAnexoSegundaVia.error = action.payload.error;
        break;
      }
      case Types.GET_SEGUNDA_VIA_ANEXO_REQUEST: {
        draft.getAnexoSegundaVia.loading = true;
        break;
      }
      case Types.GET_SEGUNDA_VIA_ANEXO_SUCCESS: {
        draft.getAnexoSegundaVia.loading = false;
        draft.getAnexoSegundaVia.response = action.payload.response;
        draft.getAnexoSegundaVia.success = action.payload.success;
        break;
      }
      case Types.GET_SEGUNDA_VIA_ANEXO_ERROR: {
        draft.getAnexoSegundaVia.loading = false;
        draft.getAnexoSegundaVia.isError = true;
        draft.getAnexoSegundaVia.error = action.payload.error;
        break;
      }
      case Types.PUT_SEGUNDA_VIA_UPDATE_REQUEST: {
        draft.putSegundaViaCartao.loading = true;
        break;
      }
      case Types.PUT_SEGUNDA_VIA_UPDATE_SUCCESS: {
        draft.putSegundaViaCartao.loading = false;
        draft.putSegundaViaCartao.response = action.payload.response;
        draft.putSegundaViaCartao.success = action.payload.success;
        break;
      }
      case Types.PUT_SEGUNDA_VIA_UPDATE_ERROR: {
        draft.putSegundaViaCartao.loading = false;
        draft.putSegundaViaCartao.isError = true;
        draft.putSegundaViaCartao.error = action.payload.error;
        break;
      }
      case Types.POST_SEGUNDA_VIA_PROCESSAR_REQUEST: {
        draft.postProcessarSegundaVia.loading = true;
        break;
      }
      case Types.POST_SEGUNDA_VIA_PROCESSAR_SUCCESS: {
        draft.postProcessarSegundaVia.loading = false;
        draft.postProcessarSegundaVia.response = action.payload.response;
        draft.postProcessarSegundaVia.success = action.payload.success;
        break;
      }
      case Types.POST_SEGUNDA_VIA_PROCESSAR_ERROR: {
        draft.postProcessarSegundaVia.loading = false;
        draft.postProcessarSegundaVia.isError = true;
        draft.postProcessarSegundaVia.error = action.payload.error;
        break;
      }
      case Types.POST_SEGUNDA_VIA_BUSCAR_POR_ID_REQUEST: {
        draft.getSegundaViaCartao.loading = true;
        break;
      }
      case Types.POST_SEGUNDA_VIA_BUSCAR_POR_ID_SUCCESS: {
        draft.getSegundaViaCartao.loading = false;
        draft.getSegundaViaCartao.response = action.payload.response;
        draft.getSegundaViaCartao.success = action.payload.success;
        break;
      }
      case Types.POST_SEGUNDA_VIA_BUSCAR_POR_ID_ERROR: {
        draft.getSegundaViaCartao.loading = false;
        draft.getSegundaViaCartao.isError = true;
        draft.getSegundaViaCartao.error = action.payload.error;
        break;
      }
      case Types.POST_SEGUNDA_VIA_CARTAO_REQUEST: {
        draft.getSegundaViaCartao.loading = true;
        break;
      }
      case Types.POST_SEGUNDA_VIA_CARTAO_SUCCESS: {
        draft.getSegundaViaCartao.loading = false;
        draft.getSegundaViaCartao.response = action.payload.response;
        draft.getSegundaViaCartao.success = action.payload.success;
        break;
      }
      case Types.POST_SEGUNDA_VIA_CARTAO_ERROR: {
        draft.getSegundaViaCartao.loading = false;
        draft.getSegundaViaCartao.isError = true;
        draft.getSegundaViaCartao.error = action.payload.error;
        break;
      }
      default:
    }
  });
}

export const Creators = {
  getPermissaoSegundaViaRequest: (params) => ({
    type: Types.GET_PERMISSAO_SEGUNDA_VIA_REQUEST,
    payload: { params },
  }),
  getPermissaoSegundaViaSuccess: (response, success) => ({
    type: Types.GET_PERMISSAO_SEGUNDA_VIA_SUCCESS,
    payload: { response, success },
  }),
  getPermissaoSegundaViaError: (error) => ({
    type: Types.GET_PERMISSAO_SEGUNDA_VIA_ERROR,
    payload: { error },
  }),
  postSolicitarRelatorioSegundaViaRequest: (params) => ({
    type: Types.POST_SOLICITAR_RELATORIO_SEGUNDA_VIA_REQUEST,
    payload: { params },
  }),
  postSolicitarRelatorioSegundaViaSuccess: (response, success) => ({
    type: Types.POST_SOLICITAR_RELATORIO_SEGUNDA_VIA_SUCCESS,
    payload: { response, success },
  }),
  postSolicitarRelatorioSegundaViaError: (error) => ({
    type: Types.POST_SOLICITAR_RELATORIO_SEGUNDA_VIA_ERROR,
    payload: { error },
  }),
  postSolicitarSegundaViaRequest: (params) => ({
    type: Types.POST_SOLICITAR_SEGUNDA_VIA_REQUEST,
    payload: { params },
  }),
  postSolicitarSegundaViaSuccess: (response, success) => ({
    type: Types.POST_SOLICITAR_SEGUNDA_VIA_SUCCESS,
    payload: { response, success },
  }),
  postSolicitarSegundaViaError: (error) => ({
    type: Types.POST_SOLICITAR_SEGUNDA_VIA_ERROR,
    payload: { error },
  }),
  postBeneficiarioSegundaViaRequest: (params) => ({
    type: Types.POST_BENEFICIARIOS_SEGUNDA_VIA_REQUEST,
    payload: { params },
  }),
  postBeneficiarioegundaViaSuccess: (response, success) => ({
    type: Types.POST_BENEFICIARIOS_SEGUNDA_VIA_SUCCESS,
    payload: { response, success },
  }),
  postBeneficiarioSegundaViaError: (error) => ({
    type: Types.POST_BENEFICIARIOS_SEGUNDA_VIA_ERROR,
    payload: { error },
  }),
  deleteSegundaViaRequest: (params) => ({
    type: Types.DELETE_SEGUNDA_VIA_REQUEST,
    payload: { params },
  }),
  deleteSegundaViaSuccess: (response, success) => ({
    type: Types.DELETE_SEGUNDA_VIA_SUCCESS,
    payload: { response, success },
  }),
  deleteSegundaViaError: (error) => ({
    type: Types.DELETE_SEGUNDA_VIA_ERROR,
    payload: { error },
  }),
  deleteSegundaViaAnexoRequest: (params) => ({
    type: Types.DELETE_SEGUNDA_VIA_ANEXO_REQUEST,
    payload: { params },
  }),
  deleteSegundaViaAnexoSuccess: (response, success) => ({
    type: Types.DELETE_SEGUNDA_VIA_ANEXO_SUCCESS,
    payload: { response, success },
  }),
  deleteSegundaViaAnexoError: (error) => ({
    type: Types.DELETE_SEGUNDA_VIA_ANEXO_ERROR,
    payload: { error },
  }),
  getSegundaViaAnexoRequest: (params) => ({
    type: Types.GET_SEGUNDA_VIA_ANEXO_REQUEST,
    payload: { params },
  }),
  getSegundaViaAnexoSuccess: (response, success) => ({
    type: Types.GET_SEGUNDA_VIA_ANEXO_SUCCESS,
    payload: { response, success },
  }),
  getSegundaViaAnexoError: (error) => ({
    type: Types.GET_SEGUNDA_VIA_ANEXO_ERROR,
    payload: { error },
  }),
  putSegundaViaUpdateRequest: (params) => ({
    type: Types.PUT_SEGUNDA_VIA_UPDATE_REQUEST,
    payload: { params },
  }),
  putSegundaViaUpdateSuccess: (response, success) => ({
    type: Types.PUT_SEGUNDA_VIA_UPDATE_SUCCESS,
    payload: { response, success },
  }),
  putSegundaViaUpdateError: (error) => ({
    type: Types.PUT_SEGUNDA_VIA_UPDATE_ERROR,
    payload: { error },
  }),
  postSegundaViaProcessarRequest: (params) => ({
    type: Types.POST_SEGUNDA_VIA_PROCESSAR_REQUEST,
    payload: { params },
  }),
  postSegundaViaProcessarSuccess: (response, success) => ({
    type: Types.POST_SEGUNDA_VIA_PROCESSAR_SUCCESS,
    payload: { response, success },
  }),
  postSegundaViaProcessarError: (error) => ({
    type: Types.POST_SEGUNDA_VIA_PROCESSAR_ERROR,
    payload: { error },
  }),
  postSegundaViaBuscarPorIdRequest: (params) => ({
    type: Types.POST_SEGUNDA_VIA_BUSCAR_POR_ID_REQUEST,
    payload: { params },
  }),
  postSegundaViaBuscarPorIdSuccess: (response, success) => ({
    type: Types.POST_SEGUNDA_VIA_BUSCAR_POR_ID_SUCCESS,
    payload: { response, success },
  }),
  postSegundaViaBuscarPorIdError: (error) => ({
    type: Types.POST_SEGUNDA_VIA_BUSCAR_POR_ID_ERROR,
    payload: { error },
  }),
  postSegundaViaCartaoRequest: (params) => ({
    type: Types.POST_SEGUNDA_VIA_CARTAO_REQUEST,
    payload: { params },
  }),
  postSegundaViaCartaoSuccess: (response, success) => ({
    type: Types.POST_SEGUNDA_VIA_CARTAO_SUCCESS,
    payload: { response, success },
  }),
  postSegundaViaCartaoError: (error) => ({
    type: Types.POST_SEGUNDA_VIA_CARTAO_ERROR,
    payload: { error },
  }),
};
